import PropTypes from "prop-types";
import { memo } from "react";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { useSelector } from "react-redux";
import { addOptionsToCloundinaryURL } from "app/utils/image/cloudinaryUtils";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const MAX_WIDTHS = {
	small: 768,
	medium: 978,
	large: 1440,
	xlarge: 1440,
};

const IMG_STYLES = {
	width: "100%",
	display: "block",
	height: "100%",
};

const SwiperLazyImage = ({ alt, src, quality, sizes = {}, productUri }) => {
	const { track } = useAnalytics();
	const resolution = useSelector(state => state.resolution);
	const cloudinarify = () => {
		let cloudinaryConfig = [];

		const size = sizes && sizes[resolution];

		if (size && size.width) {
			cloudinaryConfig.push(`w_${size.width}`);
		} else {
			cloudinaryConfig.push(`w_${MAX_WIDTHS[resolution]}`);
		}

		if (size && size.height) {
			cloudinaryConfig.push(`h_${size.height},c_fill,g_center`);
		}

		if (src) {
			return addOptionsToCloundinaryURL(src, cloudinaryConfig, {
				quality: quality,
			});
		}

		return "";
	};

	const source = cloudinarify();

	return (
		resolution !== RESOLUTION.UNKNOWN &&
		sizes[resolution] !== undefined && (
			<img
				className="progressive-img"
				loading="lazy"
				onError={() =>
					track("image_not_loaded", {
						url: source,
						uri: productUri,
					})
				}
				style={IMG_STYLES}
				alt={alt}
				src={source}
			/>
		)
	);
};

SwiperLazyImage.propTypes = {
	sizes: PropTypes.shape({
		small: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
		medium: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
		large: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
		xlarge: PropTypes.shape({
			height: PropTypes.number,
			width: PropTypes.number,
		}),
	}),
	alt: PropTypes.string,
	src: PropTypes.string,
	quality: PropTypes.string,
	productUri: PropTypes.string,
};

export default memo(SwiperLazyImage);
